import React, { useEffect, useState } from 'react';
import api from '../../lib/api';
import { formatCurrency } from '../../mock';
import { DataTable, Ribbon } from './shared';

const bucketCls = (b) => (b === '90+' ? 't-bad' : b === '61-90' ? 't-warn' : b === '31-60' ? '' : 't-ok');

export const AgingReport = () => {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get('/reports/inventory-aging'); setD(data); }
      catch (e) { setD(null); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <p className="ent-empty">Calculando aging do estoque…</p>;
  if (!d) return <p className="ent-empty">Não foi possível carregar o aging.</p>;
  const k = d.kpis;
  const fin = d.fin_view;

  const cols = [
    { key: 'days_in_stock', label: 'DIAS', align: 'right', render: (r) => <span className={`font-bold ${bucketCls(r.bucket)}`}>{r.days_in_stock}d</span> },
    { key: 'vehicle', label: 'VEÍCULO', render: (r) => (<div><p className="font-semibold">{r.vehicle}</p><p className="text-[10px] text-muted-foreground/70">#{r.stock || '—'} · {r.vin?.slice(-8)} · {r.km?.toLocaleString()} mi</p></div>) },
    { key: 'status', label: 'STATUS', render: (r) => <span className="ent-tag">{r.inventory_status || r.status}</span> },
    { key: 'price', label: 'PREÇO', align: 'right', render: (r) => formatCurrency(r.price) },
    ...(fin ? [
      { key: 'total_cost', label: 'CUSTO TOTAL', align: 'right', render: (r) => formatCurrency(r.total_cost) },
      { key: 'margin', label: 'MARGEM', align: 'right', render: (r) => <span className={r.margin > 0 ? 't-ok' : 't-bad'}>{formatCurrency(r.margin)}</span> },
      { key: 'margin_pct', label: '% MARGEM', align: 'right', render: (r) => `${r.margin_pct}%` },
    ] : []),
    { key: 'price_drops', label: 'BAIXAS DE PREÇO', align: 'right' },
    { key: 'photos', label: 'FOTOS', align: 'right', render: (r) => <span className={r.photos ? '' : 't-bad'}>{r.photos}</span> },
    { key: 'floor_plan', label: 'FLOOR PLAN', hide: 'hidden xl:table-cell', render: (r) => r.floor_plan || '—' },
  ];

  return (
    <div className="space-y-3" data-testid="aging-report">
      <Ribbon testid="aging-kpis" items={[
        ['Veículos disponíveis', k.units],
        ['Dias médios em estoque', `${k.avg_days}d`, k.avg_days > 60 ? 't-bad' : k.avg_days > 40 ? 't-warn' : 't-ok'],
        ['Acima de 60 dias', k.over_60, k.over_60 ? 't-bad' : 't-ok'],
        ['0-30 dias', k.buckets['0-30'], 't-ok'],
        ['31-60 dias', k.buckets['31-60']],
        ['61-90 dias', k.buckets['61-90'], 't-warn'],
        ['90+ dias', k.buckets['90+'], 't-bad'],
        ['Valor de varejo', formatCurrency(k.retail_value)],
        ['Valor parado (>60d)', formatCurrency(k.aged_value), 't-warn'],
        fin && ['Investido', formatCurrency(k.invested)],
      ]} />

      <div className="ent-panel">
        <div className="ent-panel-head"><span className="ent-label">Ranking — mais tempo em estoque</span><span className="ent-pill">{d.rows.length}</span></div>
        <DataTable testid="aging-rows" cols={cols} rows={d.rows} rowKey="vehicle_id" empty="Nenhum veículo disponível em estoque" />
      </div>

      <div className="ent-panel">
        <div className="ent-panel-head"><span className="ent-label">Média de dias por marca</span></div>
        <DataTable testid="aging-makes" rowKey="key" rows={d.by_make} cols={[
          { key: 'key', label: 'MARCA', render: (r) => <span className="font-semibold">{r.key}</span> },
          { key: 'units', label: 'UNIDADES', align: 'right' },
          { key: 'avg_days', label: 'DIAS MÉDIOS', align: 'right', render: (r) => <span className={r.avg_days > 60 ? 't-bad' : r.avg_days > 40 ? 't-warn' : ''}>{r.avg_days}d</span> },
        ]} />
      </div>
    </div>
  );
};
